import styled from '@emotion/styled'

import { transientOptions } from '../../../../constants/transientOptions'
import { Color } from '../../../../enums/color'
import { DefaultValue } from '../../../../enums/defaultValue'
import { Spacing } from '../../../../enums/spacing'
import { Asable } from '../../../../types/asable'
import { getDefaultTransition } from '../../../../utils/getDefaultTransition'

type NavListItemViewWrapperProps = Asable

export const NavListItemViewWrapper = styled.li<NavListItemViewWrapperProps>``

interface NavListItemViewProps {
  // $ at the beginning is intentional in order to avoid console warnings
  $backgroundColor?: Color
  $color: Color
  $readonly?: boolean
}

export const NavListItemView = styled('div', transientOptions)<NavListItemViewProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S12};
  height: 34px;
  padding: ${Spacing.S8};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ $backgroundColor }) => $backgroundColor || 'inherit'};
  color: ${({ $color }) => $color};
  cursor: ${({ $readonly }) => ($readonly ? 'default' : 'pointer')};
  ${getDefaultTransition('background-color')};
`
